import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

// Authentication system with role-based access control
// ProtectedRoute component handles authentication and authorization

// Import components
import Header from './components/Header';
import Dashboard from './components/Dashboard';
import Checkin from './components/Checkin';
import Checkout from './components/Checkout';
import Reports from './components/Reports';
import Partners from './components/Partners';
import Checkers from './components/Checkers';
import Docks from './components/Docks';
import Companies from './components/Companies';
import UserManagement from './components/UserManagement';
import PhoneManagement from './components/PhoneManagement';
import MessageManagement from './components/MessageManagement';
import Painel from './components/Painel';
import Diaristas from './components/Diaristas';
import Welcome from './components/Welcome';
import Login from './components/Login';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';

// Protected route component with role-based access control
// Checks for valid authentication token and verifies user role permissions
const ProtectedRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user'));
  
  // If no token, redirect to login
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  // If user role is not in allowed roles, redirect to welcome page
  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    return <Navigate to="/welcome" replace />;
  }
  
  return children;
};

function App() {
  return (
    <Router>
      <div className="app">
        <Header />
        <div className="main-content">
          <Routes>
            <Route path="/" element={<Navigate to="/welcome" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/welcome" element={
              <ProtectedRoute>
                <Welcome />
              </ProtectedRoute>
            } />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/checkin" element={
              <ProtectedRoute allowedRoles={['Operador', 'Supervisor', 'Administrador']}>
                <Checkin />
              </ProtectedRoute>
            } />
            <Route path="/checkout" element={
              <ProtectedRoute allowedRoles={['Operador', 'Supervisor', 'Administrador']}>
                <Checkout />
              </ProtectedRoute>
            } />
            <Route path="/reports" element={
              <ProtectedRoute allowedRoles={['Supervisor', 'Administrador']}>
                <Reports />
              </ProtectedRoute>
            } />
            <Route path="/partners" element={
              <ProtectedRoute allowedRoles={['Supervisor', 'Administrador']}>
                <Partners />
              </ProtectedRoute>
            } />
            <Route path="/checkers" element={
              <ProtectedRoute allowedRoles={['Supervisor', 'Administrador']}>
                <Checkers />
              </ProtectedRoute>
            } />
            <Route path="/docks" element={
              <ProtectedRoute allowedRoles={['Supervisor', 'Administrador']}>
                <Docks />
              </ProtectedRoute>
            } />
            <Route path="/companies" element={
              <ProtectedRoute allowedRoles={['Administrador']}>
                <Companies />
              </ProtectedRoute>
            } />
            
            <Route path="/users" element={
              <ProtectedRoute allowedRoles={['Administrador']}>
                <UserManagement />
              </ProtectedRoute>
            } />
            
            <Route path="/phones" element={
              <ProtectedRoute allowedRoles={['Administrador']}>
                <PhoneManagement />
              </ProtectedRoute>
            } />
            
            <Route path="/messages" element={
              <ProtectedRoute allowedRoles={['Administrador']}>
                <MessageManagement />
              </ProtectedRoute>
            } />
            
            <Route path="/painel" element={
              <ProtectedRoute allowedRoles={['Supervisor', 'Administrador']}>
                <Painel />
              </ProtectedRoute>
            } />
            
            <Route path="/diaristas" element={
              <ProtectedRoute allowedRoles={['Supervisor', 'Administrador']}>
                <Diaristas />
              </ProtectedRoute>
            } />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;